import React from 'react'
import PropTypes from 'prop-types'

import { useTheme } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Heading } from 'Components/Blocks/_Legacy'
import { Border, Motion, Row, Wrapper } from 'Components/UI'
import { Button, Icon, Text } from 'Components/UI/_Legacy'

import {
  briefcaseGlyph,
  briefcaseTimerGlyph,
  calendar2Glyph,
  iconElement3Glyph,
} from 'Assets/_Legacy/CtoPage'
import arrowRightShortGlyph from 'Assets/_Legacy/Svg/arrow-right-short.svg'

import { useAppContext } from 'Services/AppContext'

import {
  ButtonHolder,
  Card,
  CardsContainer,
  Container,
  Content,
} from './styles'

const CARD_ICONS = [briefcaseTimerGlyph, briefcaseGlyph, calendar2Glyph]

function WeOffer({ data }) {
  const { openSupportWidget } = useAppContext()
  const theme = useTheme()

  return (
    <>
      <Border bg={themeGet('colors.bg.tertiary')({ theme })} primary topRight />

      <Container>
        <Wrapper>
          <Content>
            <Motion>
              <Heading
                fontSizes={{ title: [24, 24, 45], sub: [14, 14, 16] }}
                horizontalAlign={['left', 'left', 'center']}
                light
                mb={[8, 8, 17]}
                tagGlyph={iconElement3Glyph}
                tagText={data?.weOfferTagText}
                titleText={{
                  first: { text: data?.weOfferTitleRegular, bold: false },
                  second: { text: data?.weOfferTitleBold, bold: true },
                }}
              />
            </Motion>

            <Motion>
              <CardsContainer>
                {data?.weOfferCard?.map((card, index) => (
                  <Card key={card.id}>
                    <Row center mb={4}>
                      <Icon glyph={CARD_ICONS[index]} size={40} />

                      <Text
                        as="h3"
                        bold
                        fontSize={[16, 16, 16, 20]}
                        ml={5}
                        white
                      >
                        {card?.cardTitle}
                      </Text>
                    </Row>

                    <Text fontSize={[14, 14, 14, 16]} light white>
                      {card?.cardText}
                    </Text>
                  </Card>
                ))}
              </CardsContainer>
            </Motion>

            <Motion>
              <ButtonHolder>
                <Button
                  height={60}
                  mt={11}
                  white
                  width={250}
                  onClick={openSupportWidget}
                >
                  {data?.weOfferLinkText}
                  &nbsp;
                  <Icon glyph={arrowRightShortGlyph} size={10} />
                </Button>
              </ButtonHolder>
            </Motion>
          </Content>
        </Wrapper>
      </Container>

      <Border bottomLeft primary />

      <Border bg={themeGet('colors.bg.primary')({ theme })} topRight />
    </>
  )
}

WeOffer.defaultProps = {
  data: {},
}

WeOffer.propTypes = {
  data: PropTypes.object,
}

export default WeOffer
